import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.29 8.71c.2.19.45.29.71.29l-.01-.01a.996.996 0 0 0 .71-1.7l-4.953-4.953a.996.996 0 0 0-1.457-.047L6.3 7.3a.996.996 0 1 0 1.41 1.41L11 5.412V17c0 .55.45 1 1 1s1-.45 1-1V5.412zM5 22c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1z"
    />
  </svg>
);
export default SvgArrowUpFromLine;
